export const getMessageFields = {
  Message: [
    'text',
    'text_edited_at',
    'mine',
    'attachments',
    'created_at',
    'deleted_at',
    'author',
    'reaction_counts',
    'reply_count',
    'reply_root',
    'idempotent_key',
    'message_type',
    'person_ids_for_system_event',
    'system_text_parts',
    'system_text_format',
  ],
  Person: ['name', 'avatar'],
  ReactionCount: ['value', 'count', 'mine', 'message_id', 'author_ids'],
}

export const getMessagesInclude = ['author', 'reaction_counts', 'reply_root', 'reply_root.author']
